import axios from 'axios'

export default class {
  _documentsUrl
  constructor() {
    this._documentsUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_DOCUMENTS_OPERATION}`
    this._foldersUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_GET_FOLDER}`
  }

  getDocuments(options) {
    let params = options ? '?' : ''
    params += options.page ? `page=${options.page}&` : ''
    params += options.size ? `size=${options.size}&` : ''
    params += options.sort ? `sort=${options.sort}&` : ''
    params += options.order ? `order=${options.order}&` : ''
    params += options.search ? `search=${options.search}&` : ''
    
    return axios.get(`${this._documentsUrl}${params}`)
  }

  getDocumentsByFolder(options) {
    let params = options ? '?' : ''
    params += options.page ? `page=${options.page}&` : ''
    params += options.size ? `size=${options.size}&` : ''
    
    return axios.get(`${this._foldersUrl}/${options.idCarpeta}/documents${params}`)
  }

  deleteDocument(id) {
    return axios.delete(`${this._documentsUrl}/${id}`)
  }

  updateDescripcion(document) {
    return axios.put(`${this._documentsUrl}/${document.idDocumento}`, {
      descripcion: document.descripcion
    })
  }

  updateDocument(id, document) {
    return axios.put(`${this._documentsUrl}/${id}`, document)
  }
}
